// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ASQ9","top":"styles_top__3CO5k"};